// extracted by mini-css-extract-plugin
export var button = "team-module--button--76316";
export var container = "team-module--container--94fac";
export var content = "team-module--content--d5a27";
export var decor = "team-module--decor--194d6";
export var expanded = "team-module--expanded--81ae9";
export var image = "team-module--image--826fe";
export var lineAbove = "team-module--lineAbove--dc720";
export var mobile = "team-module--mobile--07047";
export var name = "team-module--name--4c812";
export var relativeWrapper = "team-module--relativeWrapper--4d0e3";
export var teamItem = "team-module--teamItem--fd41d";
export var teamList = "team-module--teamList--e8e4d";